import { Routes } from '@angular/router';
import { ViewRoutes } from './views/views.routing';
import { AuthGuard } from '../../../abraj-shared/src/lib/guards/auth.guard';

export const routes: Routes = [
    {
            path:'',loadComponent:()=> import('./views/views.component').then(m => m.ViewsComponent ),children: ViewRoutes,canActivate: [AuthGuard],
    }
];
